import $api from "../http";
import { AxiosResponse } from "axios";
import { IStation } from "../models/IUser";

export default class StationOwnerService {
  // Получить станции владельца
  static getMyStations(): Promise<AxiosResponse<IStation[]>> {
    return $api.get<IStation[]>("/myStations");
  }
}
